// Features/Roomvo-Button/mod.ts
var interval = setInterval(probe, 500);
var attempts = 0;
function probe() {
  attempts++;
  if (attempts > 10) {
    clearInterval(interval);
    console.error(`Failed to probe for roomvo`);
    show();
    return;
  }
  const roomvo = window._roomvo;
  if (!roomvo) {
    show();
    return;
  }
  clearInterval(interval);
  const map = roomvo?.bodenglueckde?.productCodeMap ?? {};
  const entries = Object.entries(map);
  const isValid = !!entries[0]?.[1].length;
  if (isValid) {
    show();
    return;
  }
}
function show() {
  document.querySelectorAll(`.roomvo-container`).forEach((element) => element.style.display = "");
}
